/**
 * Eventos do terminal para a nuvem — docs/09-POS-PROPOSTA.md §3 (arquitecto) e §5.1.
 *
 * Tudo o que o terminal faz (venda emitida, abertura/fecho de caixa,
 * sangria, movimento de stock) vira um evento só de inserção. Cada evento tem
 * um UUIDv7 (ordenável no tempo, gerado offline sem colisões) e um número de
 * sequência do terminal, contínuo: o servidor guarda o último `seq` aceite por
 * terminal, responde `duplicate` a reenvios e detecta buracos (evento perdido).
 */
/** UUID versão 7 (RFC 9562): 48 bits de milissegundos + aleatório. */
export function uuidv7(now = new Date(), random = randomBytes) {
    const ms = now.getTime();
    if (!Number.isSafeInteger(ms) || ms < 0)
        throw new RangeError('Data inválida para UUIDv7');
    const b = random(16);
    if (b.length !== 16)
        throw new RangeError('São precisos 16 bytes aleatórios');
    let t = ms;
    for (let i = 5; i >= 0; i--) {
        b[i] = t % 256;
        t = Math.floor(t / 256);
    }
    b[6] = (b[6] & 0x0f) | 0x70;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
/** Próximo evento do terminal, a seguir a `lastSeq` (0 antes do primeiro). */
export function nextEvent(p) {
    if (!Number.isInteger(p.lastSeq) || p.lastSeq < 0)
        throw new RangeError('lastSeq inválido');
    const now = p.now ?? new Date();
    return { id: uuidv7(now), terminalId: p.terminalId, seq: p.lastSeq + 1, type: p.type, occurredAt: now.toISOString(), payload: p.payload };
}
/**
 * Regra do servidor para um evento recebido, dado o último `seq` já aceite
 * desse terminal. Os eventos aplicam-se por ordem: um buraco faz o servidor
 * pedir o reenvio a partir de `expected`, em vez de aceitar fora de ordem.
 */
export function receiveDecision(lastAcceptedSeq, incomingSeq) {
    if (incomingSeq <= lastAcceptedSeq)
        return 'duplicate';
    if (incomingSeq === lastAcceptedSeq + 1)
        return 'accepted';
    return { gap: { expected: lastAcceptedSeq + 1, got: incomingSeq } };
}
function randomBytes(n) {
    return globalThis.crypto.getRandomValues(new Uint8Array(n));
}
//# sourceMappingURL=outbox.js.map